import React from 'react'
import PropTypes from 'prop-types'
import { useLocation, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import placeholderLogo from 'images/icons/labelPlaceholder.png'
import { Table2 } from 'components'

const LabelsTable = ({ items }) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const searchBackTo = `${location.pathname}${location.search}${location.hash}`

  const handleClick = (item) => {
    navigate(`/search/releases/label?q=${encodeURIComponent(item.label)}`, {
      state: { searchBackTo }
    })
  }

  const columns = [
    {
      image: true,
      src: 'logo',
      cellStyleName: 'release-coverart',
      fallback: placeholderLogo
    },
    {
      title: t('release-list.label'),
      sort: 'label',
      field: 'label',
      cellStyleName: 'release-label',
      resizable: true
    },
    {
      title: t('release-list.releases'),
      sort: 'releases',
      field: 'releases',
      cellStyleName: 'release-releases'
    }
  ]

  return (
    <Table2
      tableId="labels"
      items={items}
      columns={columns}
      onClick={handleClick}
    />
  )
}

LabelsTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object)
}

export default LabelsTable
